import Container from '../../elements/Container'
import Spinner from '../../elements/Spinner'
import styles from './styles.module.scss'
import { useResponsive } from '../../../providers/ResponsiveContext'

const LoadingPage = ({
  title = 'Loading',
  subtitle = false,
  spinner = true
}) => {
  const { isTablet } = useResponsive()

  return (
    <div className={styles.page}>
      <Container variant={['-xs2']}>
        <h1>{title}</h1>

        {subtitle && <p>{subtitle}</p>}
        {spinner && (
          <div className={styles.page__spinner}>
            <Spinner variant={[!isTablet && 'xl', 'darker']} />
          </div>
        )}
      </Container>
    </div>
  )
}

export default LoadingPage
